import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Inverter } from '../../shared';
import { InputAdornment, TextField } from '@mui/material';

const invertersRequiringNominalPower = [
  Inverter.SolarEdgeGrid,
  Inverter.GoodWeGridNext,
  Inverter.SolaxMICGrid,
];

type Props = {
  inverterType: Inverter;
  nominalPower: string;
  onNominalPowerChange: (value: string) => void;
  showErrors?: boolean;
};

export const InverterParameters = ({
  inverterType,
  nominalPower,
  onNominalPowerChange,
  showErrors = false,
}: Props) => {
  if (!invertersRequiringNominalPower.includes(inverterType)) {
    return null;
  }

  const nominalPowerNumber =
    nominalPower.trim() === '' ? undefined : Number(nominalPower);
  const nominalPowerInvalid =
    nominalPowerNumber === undefined || Number.isNaN(nominalPowerNumber);

  return (
    <TextField
      label={
        <FormattedMessage
          id="inverter_wizard.nominal_power"
          defaultMessage="Nominální výkon střídače"
        />
      }
      type="number"
      value={nominalPower}
      onChange={(e) => onNominalPowerChange(e.target.value)}
      fullWidth
      required
      error={showErrors && nominalPowerInvalid}
      helperText={
        showErrors && nominalPowerInvalid ? (
          <FormattedMessage
            id="inverter_wizard.nominal_power.validation"
            defaultMessage="Zadejte nominální výkon střídače v kW."
          />
        ) : (
          <FormattedMessage
            id="inverter_wizard.nominal_power.helper"
            defaultMessage="Rozsah: 1 až 100 kW"
          />
        )
      }
      inputProps={{ min: 1, max: 100, step: 1 }}
      InputProps={{
        endAdornment: <InputAdornment position="end">kW</InputAdornment>,
      }}
    />
  );
};
